/**
 * Helper pour ouvrir le modal d'attribution
 * @param {Object} store - Instance du store Vuex
 * @param {Object} params - Paramètres pour l'attribution
 * @param {Array|String} params.lots - ID(s) du/des lot(s) à attribuer
 * @param {String} params.teamId - ID de l'équipe (optionnel)
 * @param {String} params.managerId - ID du gestionnaire (optionnel)
 */
export function openAttributionModal(store, params) {
  const { lots, teamId, managerId } = params
  
  // Convertir lots en tableau si ce n'est pas déjà le cas
  const lotsArray = Array.isArray(lots) ? lots : [lots]
  
  // Dispatcher l'action pour ouvrir le modal
  store.dispatch('attribution/openModal', {
    lots: lotsArray,
    teamId: teamId || null,
    managerId: managerId || null
  })
}

/**
 * Fermer le modal d'attribution
 * @param {Object} store - Instance du store Vuex
 */
export function closeAttributionModal(store) {
  store.dispatch('attribution/closeModal')
}
